/*
 * The basket of loaves on the baker's counter in the Master of Alkmaar's Seven Works of Mercy (1504,
 * Rijksmuseum SK-A-2815, panel 1), in metres: about as wide as the seller's forearm is long, with round
 * loaves heaped over its rim. The sizes are estimates read against the figure (docs/plans/houses.md, "Wares").
 */
export const WARE_BASKET = {
  width: 0.5,
  height: 0.22,
  depth: 0.35,
  body: 0.15,
  rim: 0.012,
  loaf: { half: 0.055, sink: 0.03 },
  /** The loaves' centres across the basket and out from its back. */
  heap: [
    [0.1, 0.1],
    [0.25, 0.09],
    [0.4, 0.1],
    [0.17, 0.25],
    [0.33, 0.25],
  ],
} as const;
